"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMessageProvider = void 0;
const react_1 = __importStar(require("react"));
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const AuthMessageProvider_context_1 = require("./AuthMessageProvider.context");
const utils_1 = require("./utils");
const AuthMessageProvider = ({ children }) => {
    const subscribers = (0, react_1.useRef)({});
    const unsubscribe = (0, react_1.useCallback)((id) => {
        delete subscribers.current[id];
    }, []);
    const subscribe = (0, react_1.useCallback)((subscriber) => {
        const id = (0, uniqueId_1.default)();
        subscribers.current[id] = subscriber;
        return id;
    }, []);
    const messageHandler = (0, react_1.useCallback)((event) => {
        (0, utils_1.onMessageReceivedFromIframe)(event, subscribers);
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('message', messageHandler, true);
        return () => window.removeEventListener('message', messageHandler, true);
    }, [messageHandler]);
    return (react_1.default.createElement(AuthMessageProvider_context_1.AuthMessageContext.Provider, { value: { subscribe, unsubscribe } }, children));
};
exports.AuthMessageProvider = AuthMessageProvider;
//# sourceMappingURL=AuthMessageProvider.js.map